var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardReq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56098 21.25C1.84533 21.25 1.23958 21.0021 0.74375 20.5063C0.247917 20.0104 0 19.4047 0 18.689V2.56098C0 1.84533 0.247917 1.23958 0.74375 0.74375C1.23958 0.247917 1.84533 0 2.56098 0H24.3557C25.0713 0 25.6771 0.247917 26.1729 0.74375C26.6687 1.23958 26.9167 1.84533 26.9167 2.56098V18.689C26.9167 19.4047 26.6687 20.0104 26.1729 20.5063C25.6771 21.0021 25.0713 21.25 24.3557 21.25H2.56098ZM2.125 10.0527H24.7917V5.53067H2.125V10.0527Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardReq);
export default __webpack_public_path__ + "static/media/credit_card_req.1142c408cbcbcfabc9be95cd011a4b6e.svg";
export { ForwardRef as ReactComponent };